import React, { useEffect, useRef, useCallback } from "react";


function GoogleSearchBox({ inputComponent, bounds, onPlacesChanged }) {
  const elementRef = useRef();
  const searchBoxObjectRef = useRef();

  const handlePlacesChanged = useCallback(() => {
    if (onPlacesChanged) {
      const places = searchBoxObjectRef.current.getPlaces();
      onPlacesChanged(places);
    }
  }, [onPlacesChanged]);

  useEffect(() => {
    if (searchBoxObjectRef.current) {

      searchBoxObjectRef.current.setBounds(bounds);

    }
  }, [bounds]);


  useEffect(() => {
    if (window.google == null) {
      return;
    }

    if (!searchBoxObjectRef.current) {
      searchBoxObjectRef.current = new window.google.maps.places.SearchBox(
        elementRef.current
      );
    }

    window.google.maps.event.clearInstanceListeners(searchBoxObjectRef.current);

    if (handlePlacesChanged) {
      searchBoxObjectRef.current.addListener(
        "places_changed",
        handlePlacesChanged
      );
    }

    return () => {
      window.google.maps.event.clearInstanceListeners(
        searchBoxObjectRef.current
      );
    };
  }, [handlePlacesChanged]);

  return (
    //Must be a MUI Input
    <inputComponent.type inputRef={elementRef} {...inputComponent.props} />
    // {/* <input
    //   ref={elementRef}
    //   placeholder="Buscar lugares"
    //   style={{
    //     boxSizing: "border-box",
    //     border: "1px solid transparent",
    //     width: "200px",
    //     height: "32px",
    //     padding: "0 12px",
    //     borderRadius: "3px",
    //     fontSize: "14px",
    //     outline: "none",
    //     textOverflow: "ellipses",
    //   }}
    //   {...props}
    //   type="text"
    // /> */}
  );
}

export default React.memo(GoogleSearchBox);
